export default __webpack_public_path__ + "static/media/bird-with-flowers.bf336fb1.png";